import { Token, gameId } from "../../../components/urlParams";
export const scratchData = {
    // API related
    baseUrl: process.env.REACT_APP_USER_API_URL,
    accessToken: null, // User's session token, if applicable
    jwtToken: Token, // JWT token received after authentication
    gameId: gameId, // Unique code for your game
    
    tokenExpired: false,

    // User data
    userId: null,
    balance: 0,
    gameLanguage: 'en',

    // Game settings (fetched from API or configured)
    betSettings: [],
    roundSettings: [],
    // ... other game-specific data
};

export const networkData = {
    dataWithJwt: null, // Stores data from JWT token response (e.g., user details, game settings)
    dataLastPendingBet: [], // Stores data from the last pending bet API response
    dataPlaceBet: null, // Stores data from the place bet API response
    dataScratchScore: null, // Stores data from scratch score API response
    ticketError: false, // Flag for ticket-related errors
    insufficientAmount: false, // Flag for insufficient balance
    betHist: [], // Array for bet history records
    isJackpot: false, // Flag for jackpot activity
    grandCurrentJackpotValue: 0,
    majorCurrentJackpotValue: 0,
    minorCurrentJackpotValue: 0,
    resetGrandJackpotValue: 0,
    resetMajorJackpotValue: 0,
    resetMinorJackpotValue: 0,
    
    allSymbolValues: [], 
    ticketsLeft: 0,
    ticketsPurchased: 0,
    currentTicket: 0,
    scratchResult: null,
    winType: null,
    winAmount: 0,
    betArray: [],
    roundArray: [],
    betPoint: 0,
    gamePoint: 0,
    buyTickets: null,
};